function escapeCell(value) {
  if (value === null || value === undefined) return "";
  const s = String(value);
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

// columns: [{ label, key?, get?(row) }]. data: array of rows.
export function exportToCsv(filename, columns, data) {
  const header = columns.map((c) => escapeCell(c.label)).join(",");
  const lines = (data || []).map((row) =>
    columns.map((c) => escapeCell(c.get ? c.get(row) : row[c.key])).join(",")
  );
  const csv = [header, ...lines].join("\n");
  const blob = new Blob(["\ufeff" + csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  const stamp = new Date().toISOString().slice(0, 10);
  a.href = url;
  a.download = `${filename}-${stamp}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
